import './styles.scss';
import type { AmazonOrderRequestProduct, AmazonProductPrice } from '@rye-com/rye-data-layer';
import { formatPrice } from 'utils/formatters';
import AmazonLogo from 'assets/images/amazon-logo.jpg';
import { AmazonProduct } from '../../../../../../app/graphql/generated/cart/graphql';
import { MAX_PRODUCT_DESCRIPTION_LENGTH } from '../../const';
import { truncateText } from 'lib/utils';

const DEFAULT_QUANTITY = 1;

interface ItemCatalogCardValue {
  quantityMap: AmazonOrderRequestProduct[];
  productId: string;
  amazonProduct: AmazonProduct | undefined;
  price?: AmazonProductPrice;
}

export const AmazonItemCatalogCard = (props: ItemCatalogCardValue) => {
  const imageUrl = props.amazonProduct?.images?.length
    ? props.amazonProduct.images[0].url
    : AmazonLogo;

  const productUrl = `https://amazon.com/dp/${props.productId}`;

  return (
    <tr>
      <td>
        <img
          className="item-catalog-product-image"
          alt={props.amazonProduct?.title}
          src={imageUrl}
        />
      </td>
      <td className="item-catalog-product-description">
        <div className="item-catalog-product-description-row">
          {props.amazonProduct ? (
            <>
              <b>Name</b>
              <div>{props.amazonProduct.title}</div>
            </>
          ) : (
            <>
              <b>Product ID</b>
              <div>{props.productId} (data unavailable)</div>
            </>
          )}
        </div>
        {props.amazonProduct?.description && (
          <div className="item-catalog-product-description-row">
            <b>Description</b>
            <div>
              {truncateText(props.amazonProduct.description, MAX_PRODUCT_DESCRIPTION_LENGTH)}
            </div>
          </div>
        )}
        <div className="item-catalog-product-description-row">
          <b>Product Link</b>
          <div>
            <a href={productUrl} target="_blank" rel="noreferrer">
              {productUrl}
            </a>
          </div>
        </div>
      </td>
      <td>
        {props.quantityMap.find((requestProduct) => requestProduct.productId === props.productId)
          ?.quantity ?? DEFAULT_QUANTITY}
      </td>
      <td>
        {props.price?.value
          ? formatPrice(props.price.value / 100, props.price.currencyCode)
          : props.amazonProduct?.price?.displayValue ?? 'N/A'}
      </td>
    </tr>
  );
};
